<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lYX9F5/tc-custom/9781439122723.jpg?1730494027513" alt="This image is the cover for the book Seeing the Unseen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seeing the Unseen
      </h1>
      <p class="bookDescription body article font2">
        <b>Spiritual warfare is real, and your faith is at stake. Based on Biblical principles, <i>Seeing the Unseen</i> helps you fight back against the enemy. </b><br/><br/>In today’s world, Satan seems to be everywhere, and he seems to have the advantage. But the enemy is not of this world, and the war is in the spiritual world. Satan is trying to attack you and destroy your faith, and the only way to defeat him is to fight back.<br/><br/>In this newly revised and updated bestseller, Joe Beam reveal Satan's powerful weaponry—his lies, deceptions, and manipulations—and unmasks his strategy to destroy your life and those you care for. This book will show you his plans and tactics, and teach you where he is likely to strike next and how to fight him.<br/><br/>Based on a dedicated study of God’s word, this book is filled with stories of tragedy and triumph and will give you the tools you need to defeat the enemy.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joe Beam
      </h2>
      
      <p class="authorDescription body article"><B>Joe Beam</B> is an internationally known inspirational speaker and author. He founded Beam Research Center and serves as its chairman. He has spoken to millions of people worldwide in personal appearances as well as appearances on TV and radio, including ABC&#8217;s Good Morning America, Focus on the Family, the Montel Williams Show, NBC's Today Show, The Dave Ramsey Show, The Morning Show with Mike and Juliet, and magazines such as <I>People</I> and <I>Better Homes and Gardens</I>.<BR><BR>After earning his bachelor's degree (Magna Cum Laude) from Southern Christian University, Joe did graduate studies in clinical psychology at the University of Evansville. He is currently involved in research to complete his PhD in biomedical science at the University of Sydney, consistently rated one of the top fifty universities in the world. The emphasis of his research is in sexology.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Howard Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01f65497